/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum ValidationFaultPaymentUnknownEnum {
  "PAA_PAGAMENTO_SCONOSCIUTO" = "PAA_PAGAMENTO_SCONOSCIUTO"
}

/**
 * Fault codes for errors related to well-formed requests to ECs not present inside Nodo, should be mapped to 404 HTTP status code.
 * Most of the time these are generated when users input a wrong fiscal code or notice number.
 * For further information visit https://docs.pagopa.it/gestionedeglierrori/struttura-degli-errori/fault-code.
 * Possible fault codes are:
 * - `PAA_PAGAMENTO_SCONOSCIUTO`
 */

export type ValidationFaultPaymentUnknown = t.TypeOf<
  typeof ValidationFaultPaymentUnknown
>;
export const ValidationFaultPaymentUnknown = enumType<
  ValidationFaultPaymentUnknownEnum
>(ValidationFaultPaymentUnknownEnum, "ValidationFaultPaymentUnknown");
